import { defineComponent, ref, provide, onMounted, renderSlot } from 'vue';
import request from '../../../utils/request.mjs';
import { getPublishTimestamp } from '../../../utils/index.mjs';
import { API_BASE } from '../../../utils/getConstant.mjs';

const __default__ = defineComponent({
  name: "TvbTvbConfig"
});
var _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  props: {
    env: null
  },
  setup(__props) {
    const props = __props;
    const seo = ref({});
    ;
    provide("env", props.env || "prod");
    provide("seo", seo);
    const getSeo = () => {
      request.get(`/seo?_t=${getPublishTimestamp()}`, {
        baseURL: API_BASE(props.env || "prod")
      }).then(({ data }) => {
        seo.value = data;
        if (data.gray) {
          document.querySelector("html").style.filter = "grayscale(100%)";
        }
      });
    };
    onMounted(() => getSeo());
    return (_ctx, _cache) => {
      return renderSlot(_ctx.$slots, "default");
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=Config.vue2.mjs.map
